import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import Navbar from "../Components/Navbar";
import { isNewUser, checkRoles, isTokenValid } from "./helper";
import NotFoundPage from "../Containers/NotFoundPage/index";
import HoursPage from "../Containers/HoursPage/index";
import LogInPage from "../Containers/LogInPage/index.jsx";
import FirstTimeUserPage from "../Containers/FirstTimeUserPage";
import WorkCentersPage from "../Containers/WorkCentersPage";
import ReportingParamsPage from "../Containers/LocationReportOptPage/report";
import EmployeesOfTheMonthPage from "../Containers/EmployeeOfTheMonthPage";
import LocationDashPage from "../Containers/LocationDashPage";
import OrdersPage from "../Containers/OrdersPage";
import POPage from "../Containers/POPage";
import PODetails from "../Containers/POPage/poDetails";
import PONew from "../Containers/PONew";
import OrderDetails from "../Containers/OrderDetails";
import CompaniesPage from "../Containers/CompaniesPage";
import MiscCostsPage from "../Containers/MiscCostsPage";
import TasksPage from "../Containers/TasksPage";
import ProjectsPage from "../Containers/ProjectsPage";
import ProjectPlanPage from "../Containers/ProjectPlanPage";
import PortalPage from "../Containers/PortalPage/index";
import UserListPage from "../Containers/UserListPage/index";
import ReportHoursPage from "../Containers/ReportHoursPage";
import ProjectsReportPage from "../Containers/ProjectsReportsPage/index";
import UsersReportPage from "../Containers/UsersReportsPage/index";
import CellReportsPage from "../Containers/CellReportsPage/index";
import Dashboard from "../Containers/Dashboard/index";
import ProjectInfoPage from "../Containers/ProjectInfoPage/index";
import ResearchDashboard from "../Containers/ResearchDashboard";
import RequestSecurityCode from "../Containers/RequestSecurityCodePage/index.js";
import VerifySecurityCodePage from "../Containers/VerifySecurityCodePage";
import ResetPasswordNewPage from "../Containers/ResetPasswordNewPage";
import DeliveryLocations from "../Containers/DeliveryLocationPage";
import SupplierListPage from "../Containers/SupplierListPage";
import PCardsPage from "../Containers/PCardsPage";
import TimeOff from "../Containers/TimeOffPage/index.js";
export default function RoutesFunction() {
  const MainSite = ({ Component, showNavIfLoggedIn, props }) => {
    if (!isNewUser()) {
      if (showNavIfLoggedIn) {
        return (
          <>
            <Navbar />
            <Component props={props} />
          </>
        );
      }

      return <Component props={props} />;
    }
    return <Navigate replace to="/login/new" />;
  };

  const PrivateRoute = ({
    Component,
    authRole,
    addParams,
    props,
    noNav,
    pageTitle,
  }) => {
    if (isTokenValid() && isNewUser()) {
      return <Navigate replace to="/login/new" />;
    } else if (isTokenValid() && checkRoles(authRole) && !isNewUser()) {
      if (addParams) {
        return WithRouter(Component, props, noNav);
      } else {
        if (noNav) {
          return <Component />;
        }
        return (
          <>
            <Navbar pageTitle={pageTitle} isAdmin={checkRoles("Admin")} />
            <Component />
          </>
        );
      }
    } else if (isTokenValid() && !checkRoles(authRole)) {
      return <Navigate replace to="/404" />;
    } else if (!isTokenValid()) {
      //logout();
      return <Navigate replace to="/login" />;
    }
  };

  const NewUserOnly = () => {
    if (isTokenValid() && !isNewUser()) {
      return <Navigate replace to="/" />;
    } else if (!isTokenValid()) {
      return <Navigate replace to="/login" />;
    }
    return <FirstTimeUserPage />;
  };

  const WithRouter = (WrappedComponent, props, noNav, ...rest) => {
    const params = useParams();

    return (
      <>
        {noNav ? null : <Navbar isAdmin={checkRoles("Admin")} />}
        <WrappedComponent props={props} params={params} {...rest} />
      </>
    );
  };

  const userPortalOpt = [
      {
        name: "Upload Hours",
        link: "/hours",
        icon: "time-outline",
        restriction: checkRoles(1),
      },
      {
        name: "View Hours",
        link: "/users/uploads",
        icon: "calendar-outline",
        restriction: checkRoles(1),
      },
      {
        name: "User List",
        link: "/users",
        icon: "people-outline",
        restriction: checkRoles(2),
      },
      {
        name: "Time Offs",
        link: "/timeOff",
        icon: "time",
        restriction: checkRoles(6),
      },
    ],
    reportsPortalOpt = [
      {
        name: "Users",
        link: "/reports/users",
        icon: "person-outline",
        restriction: checkRoles(3),
      },
      {
        name: "Projects",
        link: "/reports/projects",
        icon: "reader-outline",
        restriction: checkRoles(2),
      },
      {
        name: "Cells",
        link: "/reports/cells",
        icon: "apps-outline",
        restriction: checkRoles(2),
      },
    ],
    locationPortalOpt = [
      {
        name: "WorkCenters",
        link: "/workCenters",
        icon: "grid-outline",
        restriction: checkRoles(3),
      },
      {
        name: "Companies",
        link: "/companies",
        icon: "business-outline",
        restriction: checkRoles(2),
      },
    ],
    businessPortalOpt = [
      {
        name: "Orders",
        link: "/orders",
        icon: "cart-outline",
        restriction: checkRoles(1),
      },
      {
        name: "PO Requests",
        link: "/purchaseOrders",
        icon: "bag-handle-outline",
        restriction: checkRoles(1),
      },
      {
        name: "Delivery Locations",
        link: "/deliveryLocations",
        icon: "location",
        restriction: checkRoles(5),
      },
      {
        name: "PCards",
        link: "/pCards",
        icon: "card",
        restriction: checkRoles(5),
      },
      {
        name: "Supplier List",
        link: "/supplierList",
        icon: "person",
        restriction: checkRoles(5),
      },
    ],
    projectsPortalOpt = [
      {
        name: "Projects",
        link: "/projects",
        icon: "layers-outline",
        restriction: checkRoles(1),
      },
      {
        name: "Misc Costs",
        link: "/projects/misccosts",
        icon: "bar-chart-outline",
        restriction: checkRoles(1),
      },
    ],
    mainPortalOpt = [
      { name: "Reports", list: reportsPortalOpt, restriction: checkRoles(2) },
      !checkRoles(3) &&
        !checkRoles(2) && {
          name: "Upload Hours",
          link: "/hours",
          icon: "time-outline",
          restriction: checkRoles(1),
        },
      !checkRoles(3) &&
        !checkRoles(2) && {
          name: "View My Hours",
          link: "/users/uploads",
          icon: "calendar-outline",
          restriction: checkRoles(1),
        },
      //{ name: 'Projects', link: '/projects', icon: 'layers-outline', restriction: checkRoles(1) },
      !checkRoles(6) && {
        name: "Projects",
        link: "/projects",
        icon: "layers-outline",
        restriction: checkRoles(1),
      },
      { name: "Projects", list: projectsPortalOpt, restriction: checkRoles(6) },
      { name: "Users", list: userPortalOpt, restriction: checkRoles(2) },
      {
        name: "Locations",
        list: locationPortalOpt,
        restriction: checkRoles(1),
      },
      { name: "Business", list: businessPortalOpt, restriction: checkRoles(1) },
      {
        name: "Dashboard",
        link: "/dashboard",
        icon: "desktop-outline",
        restriction: checkRoles(1),
      },
    ];

  //switch from camelcase to dashes?
  return (
    <Router>
      <Routes>
        <Route path="login">
          <Route
            path="reset"
            element={
              <MainSite
                Component={RequestSecurityCode}
                showNavIfLoggedIn={false}
              />
            }
          />
          <Route
            path="verifySecurityCode"
            element={
              <MainSite
                Component={VerifySecurityCodePage}
                showNavIfLoggedIn={false}
              />
            }
          />
          <Route
            path="resetPassword"
            element={
              <MainSite
                Component={ResetPasswordNewPage}
                showNavIfLoggedIn={false}
              />
            }
          />
          <Route path="new" element={NewUserOnly()} />
          <Route
            index
            element={
              <MainSite Component={LogInPage} showNavIfLoggedIn={false} />
            }
          />
        </Route>
        <Route path="workCenters">
          <Route
            index
            element={
              <PrivateRoute
                authRole="Program-Manager"
                authRole={3}
                Component={WorkCentersPage}
                pageTitle={"Work Centers"}
              />
            }
          />
          {/*<Route path=":id" element={<MainSite Component={LocationDashPage} />} />*/}
          <Route
            path="reporting/:name"
            element={
              <PrivateRoute
                authRole={5}
                Component={ReportingParamsPage}
                pageTitle={"Reporting Params"}
              />
            }
          />
          <Route
            path=":taskId"
            element={
              <PrivateRoute
                authRole={6}
                Component={TasksPage}
                pageTitle={"Task Rates"}
              />
            }
          />
        </Route>
        <Route path="companies">
          <Route
            index
            element={
              <PrivateRoute
                authRole={3}
                Component={CompaniesPage}
                pageTitle={"Companies"}
                addParams
              />
            }
          />
        </Route>
        <Route path="users">
          <Route
            path=":userId"
            element={
              <PrivateRoute
                authRole={2}
                Component={ReportHoursPage}
                props={{ user: true }}
                addParams
              />
            }
          />
          <Route
            path="uploads"
            element={
              <PrivateRoute
                authRole={1}
                Component={ReportHoursPage}
                props={{ user: false }}
                addParams
                pageTitle={"Hour Report"}
              />
            }
          />
          <Route
            path=":userId/hours"
            element={
              <PrivateRoute
                authRole={2}
                props={{ project: false, admin: true }}
                Component={HoursPage}
                addParams
              />
            }
          />
          <Route
            path="categories"
            element={
              <PrivateRoute
                authRole={2}
                Component={PortalPage}
                props={{
                  options: userPortalOpt,
                  showLogout: false,
                  cols: 3,
                  subHeading: "Select a category below to navigate.",
                  heading: "User Categories",
                  showBackBtn: true,
                }}
                addParams
                noNav
              />
            }
          />
          <Route
            index
            element={
              <PrivateRoute
                authRole={2}
                Component={UserListPage}
                pageTitle={"Users"}
              />
            }
          />
        </Route>
        <Route path="reports">
          <Route
            path="cells"
            element={
              <PrivateRoute
                authRole={2}
                Component={CellReportsPage}
                props={{ projects: false }}
                addParams
                pageTitle={"Cells Report"}
              />
            }
          />
          <Route
            path="users"
            element={
              <PrivateRoute
                authRole={2}
                Component={UsersReportPage}
                props={{ projects: false }}
                addParams
                pageTitle={"Users Report"}
              />
            }
          />
          <Route
            path="users/:userId"
            element={
              <PrivateRoute
                authRole={2}
                Component={UsersReportPage}
                props={{ projects: false }}
                addParams
                pageTitle={"User Report"}
              />
            }
          />
          <Route
            path="projects"
            element={
              <PrivateRoute
                authRole={2}
                Component={ProjectsReportPage}
                props={{ projects: true }}
                addParams
                pageTitle={"Projects Report"}
              />
            }
          />
          <Route
            path="projects/:projectId"
            element={
              <PrivateRoute
                authRole={2}
                Component={ProjectsReportPage}
                props={{ projects: true }}
                addParams
                pageTitle={"Project Report"}
              />
            }
          />
          <Route
            index
            element={
              <PrivateRoute
                authRole={2}
                Component={PortalPage}
                props={{
                  options: reportsPortalOpt,
                  showLogout: false,
                  cols: 3,
                  subHeading: "Select a category below to display reports.",
                  heading: "Report Categories",
                  showBackBtn: true,
                }}
                addParams
                noNav
              />
            }
          />
          <Route
            index
            element={
              <PrivateRoute
                authRole={3}
                Component={PortalPage}
                props={{
                  options: reportsPortalOpt,
                  showLogout: false,
                  cols: 2,
                }}
                addParams
              />
            }
          />
        </Route>
        <Route
          path="/"
          element={
            <PrivateRoute
              authRole={1}
              Component={PortalPage}
              props={{
                options: mainPortalOpt,
                showLogout: true,
                cols: 6,
                subHeading: "Select a category below to navigate.",
              }}
              addParams
              noNav
            />
          }
        />
        <Route path="/hours">
          <Route
            index
            element={
              <PrivateRoute
                authRole={1}
                props={{ project: false, admin: false }}
                Component={HoursPage}
                addParams
                pageTitle={"Upload Hours"}
              />
            }
          />
          <Route
            path="edit"
            element={
              <PrivateRoute
                authRole={2}
                props={{ user: true, edit: true }}
                Component={ReportHoursPage}
                addParams
              />
            }
            pageTitle={"Calendar"}
          />
        </Route>
        <Route path="dashboard">
          <Route
            index
            element={
              <PrivateRoute
                authRole={1}
                Component={Dashboard}
                pageTitle={"Dashboard"}
              />
            }
          />
        </Route>
        <Route path="researchDashboard/:billingCode">
          {/*<Route index element={<MainSite Component={ResearchDashboard} />} />*/}
          <Route
            index
            element={
              <PrivateRoute authRole={1} Component={ResearchDashboard} noNav />
            }
          />
        </Route>
        <Route path="orders">
          <Route
            index
            element={
              <PrivateRoute
                authRole={1}
                Component={OrdersPage}
                pageTitle={"Orders"}
              />
            }
          />
          <Route
            path=":orderId"
            element={
              <PrivateRoute
                authRole={1}
                Component={OrderDetails}
                addParams
                pageTitle={"Order Details"}
              />
            }
          />
        </Route>
        <Route
          path="deliveryLocations"
          element={
            <PrivateRoute
              authRole={1}
              Component={DeliveryLocations}
              addParams
              pageTitle={"Delivery Locations"}
            />
          }
        />
        <Route
          path="timeOff"
          element={
            <PrivateRoute
              authRole={1}
              Component={TimeOff}
              addParams
              pageTitle={"Time Off"}
            />
          }
        />
        <Route
          path="supplierList"
          element={
            <PrivateRoute
              authRole={1}
              Component={SupplierListPage}
              addParams
              pageTitle={"Supplier List"}
            />
          }
        />
        <Route
          path="pCards"
          element={
            <PrivateRoute
              authRole={1}
              Component={PCardsPage}
              addParams
              pageTitle={"PCards"}
            />
          }
        />
        <Route path="purchaseOrders">
          <Route
            index
            element={
              <PrivateRoute
                authRole={1}
                props={{ project: true, admin: false }}
                Component={POPage}
                pageTitle={"PO Requests"}
                addParams
              />
            }
          />
          <Route
            path=":POId"
            element={
              <PrivateRoute
                authRole={1}
                Component={PODetails}
                pageTitle={"Purchase Order Request"}
                addParams
              />
            }
          />
          <Route
            path="newPO"
            element={
              <PrivateRoute
                authRole={1}
                props={{ project: true, admin: false }}
                Component={PONew}
                pageTitle={"New PO Request"}
                addParams
              />
            }
          />
        </Route>
        <Route path="projects">
          <Route
            path="hours"
            element={
              <PrivateRoute
                authRole={1}
                props={{ project: true, admin: false }}
                Component={HoursPage}
                addParams
                pageTitle={"Upload Hours"}
              />
            }
          />
          <Route
            path="report/:projectName/:projectId"
            element={
              <PrivateRoute
                authRole={3}
                Component={ReportHoursPage}
                props={{ user: false }}
                addParams
              />
            }
          />
          <Route
            path="misccosts"
            element={
              <PrivateRoute
                authRole={1}
                Component={MiscCostsPage}
                addParams
                pageTitle={"Misc Costs"}
              />
            }
          />
          <Route
            path=":projectId"
            element={
              <PrivateRoute
                authRole={1}
                Component={ProjectPlanPage}
                addParams
                pageTitle={"Project Details"}
              />
            }
          />
          <Route
            index
            element={
              <PrivateRoute
                authRole={1}
                Component={ProjectsPage}
                pageTitle={"Projects"}
              />
            }
          />
        </Route>
        {/*Project Info Pages*/}
        <Route path="frankenstein">
          <Route
            index
            element={
              <MainSite
                Component={ProjectInfoPage}
                props={{
                  title: "Frankenstein (FS-19)",
                  subtitle:
                    "Demonstrate Agile Manufacturing of Composite Structures Through Model-Based Engineering Solutions",
                  benefits: [
                    "Material Selection \u2192 Design Allowable Development",
                    "Process Solutions \u2192 Meet Manufacturing Rate Targets",
                    "Tooling Methods \u2192 Low-Cost Rapid Prototyping to Production",
                    "Joining and Tooling Methods \u2192 Integration",
                    "Infrastructure & Equipment Cost \u2192 Factory Design",
                  ],
                  keyFacts: [
                    "30-foot-long demonstrator",
                    "Center Display: Serpentine inlet duct, model engine, tail pipe, and exhaust nozzle",
                  ],
                }}
              />
            }
          />
        </Route>
        <Route path="tpw">
          <Route
            index
            element={
              <MainSite
                Component={ProjectInfoPage}
                props={{
                  title: "Thermoplastic Welding",
                  subtitle:
                    "For High-Rate Production of Light-Weight Composite Structures",
                  benefits: [
                    "Fusion bonding does not require the rigorous surface preparation steps typically required for adhesive bonding",
                    "Process can be automated to eliminate operator dependency",
                    "The modular control system can easily be scaled up to production size",
                  ],
                  keyFacts: [],
                }}
              />
            }
          />
        </Route>
        <Route path="fpp">
          <Route
            index
            element={
              <MainSite
                Component={ProjectInfoPage}
                props={{
                  title: "Fiber Patch Placement",
                  subtitle: "Manufacturing Complex Parts at High Rates",
                  benefits: [
                    "Ability to scale for high volume",
                    "Small parts with complex geometries",
                    "Fully automated process for high-rate manufacturing",
                  ],
                  keyFacts: [
                    "Soft patching tool to conform to complex geometries",
                    "No steering issues on tight contours",
                    "Ability to integrate with model-based engineering tools for process optimization",
                  ],
                }}
              />
            }
          />
        </Route>
        <Route path="awp">
          <Route
            index
            element={
              <MainSite
                Component={ProjectInfoPage}
                props={{
                  title: "Aircraft Window Plug",
                  subtitle:
                    "Adapting Techniques from High-Rate Automotive Manufacturing to Aerospace",
                  benefits: [
                    "Fully automated process for ultra-high-rate manufacturing",
                    "Net-shape and ready to use part out of the mold",
                    "Ultra-high-rate cycle times of ~ 90s (40 parts an hour)",
                    "20% lighter than the metallic counterpart",
                    "Fully recycable",
                  ],
                  keyFacts: [
                    "Materials: Victrex AS4/AE250 LM-PAEK & 150CA30 PEEK",
                    "Equipment: KraussMaffei multi-robotic thermoforming and injection molding system",
                  ],
                }}
              />
            }
          />
        </Route>
        <Route path="hasm">
          <Route
            index
            element={
              <MainSite
                Component={ProjectInfoPage}
                props={{
                  title: "Hybrid Additive and Subtractive Manufacturing",
                  subtitle:
                    "Scalable Composite Robotic Additive Manufacturing (SCRAM++)",
                  benefits: [
                    "Additive and subtractive manufacturing in a single scale",
                    "Manufacturing of complex composite parts with melt-out tooling",
                  ],
                  keyFacts: [
                    "Polymer 3D additive",
                    "Metal 3D additive",
                    "CNC subtractive",
                    "Automated fiber placement",
                  ],
                }}
              />
            }
          />
        </Route>
        <Route
          path="employees-of-the-month"
          element={
            <PrivateRoute
              authRole={1}
              Component={EmployeesOfTheMonthPage}
              pageTitle={"Employees of the Month"}
            />
          }
        />

        <Route
          path="*"
          element={
            <MainSite Component={NotFoundPage} showNavIfLoggedIn={true} />
          }
        />
      </Routes>
    </Router>
  );
}
